import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-common-confirm-dialog',
    templateUrl: './common-confirm-dialog.component.html',
    styleUrls: ['./common-confirm-dialog.component.scss'],
    standalone: false
})

export class CommonConfirmDialogComponent implements OnInit {
    firstMessage = '';
    secondMessage = '';
    cancellable = false;
    constructor(
        public dialogRef: MatDialogRef<CommonConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }
    ngOnInit() {
        this.firstMessage = this.data.firstMessage;
        this.secondMessage = this.data.secondMessage;
        this.cancellable = this.data.cancellable;
    }
}
